import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BigNumber from "bignumber.js"; // set exponential

BigNumber.config({
  EXPONENTIAL_AT: 12
});
/**
 * get default decimal place depend on number value
 *
 * @export
 * @param {BigNumber.Value} n
 * @return {*}
 */

export function getDefaultDecimalPlace(n) {
  var num = new BigNumber(n);
  return num.gt(1e4) ? 2 : num.gt(1) ? 4 : 8;
}
/**
 * convert number to string with symbol sign
 *
 * @export
 * @param {number} n
 * @return {*}
 */

export function symbology(n) {
  return n >= 0 ? "+".concat(n) : "".concat(n);
}
/**
 * format number with certain decimal place
 *
 * @export
 * @param {{
 *   n: BigNumber.Value;
 *   dp?: number;
 *   max_dp?: number;
 *   fixed?: boolean;
 *   mode?: BigNumber.RoundingMode;
 * }} opts
 * @return {*}  {string}
 */

export function format(opts) {
  var _opts$mode;

  var num = new BigNumber(opts.n);
  var mode = (_opts$mode = opts.mode) !== null && _opts$mode !== void 0 ? _opts$mode : BigNumber.ROUND_DOWN;
  var dp = opts.dp || getDefaultDecimalPlace(num);

  if (opts.max_dp) {
    dp = Math.min(dp, opts.max_dp);
  }

  return opts.fixed ? num.toFormat(dp, mode) : num.decimalPlaces(dp, mode).toFormat();
}
/**
 * format simplize number with Intl
 *
 * @export
 * @param {{
 *   n: number;
 *   locale?: string;
 *   dp?: number;
 *   configs?: Partial<Intl.NumberFormatOptions>;
 * }} opts
 * @return {*}
 */

export function simplize(opts) {
  var _opts$configs;

  var configs = (_opts$configs = opts.configs) !== null && _opts$configs !== void 0 ? _opts$configs : {};
  var intl = new Intl.NumberFormat(opts.locale, _objectSpread({
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    notation: "compact"
  }, configs));
  return intl.format(opts.n);
}
/**
 * change number to certain decimal place without format number
 *
 * @export
 * @param {{
 *   n: BigNumber.Value;
 *   dp?: number;
 *   mode?: BigNumber.RoundingMode;
 * }} opts
 * @return {*}
 */

export function toPrecision(opts) {
  var _opts$mode2;

  var dp = opts.dp || getDefaultDecimalPlace(opts.n);
  var mode = (_opts$mode2 = opts.mode) !== null && _opts$mode2 !== void 0 ? _opts$mode2 : BigNumber.ROUND_DOWN;
  var bn = new BigNumber(opts.n);
  return bn.dp() > dp ? bn.decimalPlaces(dp, mode).toFixed(dp) : Number(opts.n).toString();
}
/**
 * change number to equal percent format
 *
 * @export
 * @param {{
 *   n: BigNumber.Value;
 *   symbol?: boolean;
 *   dp?: number;
 * }} opts
 * @return {*}
 */

export function toPercent(opts) {
  var _opts$dp = opts.dp,
      dp = _opts$dp === void 0 ? 2 : _opts$dp,
      n = opts.n,
      _opts$symbol = opts.symbol,
      symbol = _opts$symbol === void 0 ? false : _opts$symbol;
  var bn = new BigNumber(n);
  var s = symbol ? bn.gte(0) ? "+" : "" : "";
  return "".concat(s).concat(bn.multipliedBy(100).toFixed(dp), "%");
}
/**
 * get fixed number
 *
 * @export
 * @param {{ n: BigNumber.Value; p?: number }} opts
 * @return {*}
 */

export function toFixed(opts) {
  var n = opts.n,
      _opts$p = opts.p,
      p = _opts$p === void 0 ? 2 : _opts$p;
  return new BigNumber(n).toFixed(p);
}